var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteAlert = function SvgDeleteAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M10.055 2.385c-.634 0-1.147.514-1.147 1.148V4.68h6.974V3.533c0-.634-.514-1.148-1.147-1.148zm8.21 2.296V3.533A3.53 3.53 0 0 0 14.736 0h-4.68a3.53 3.53 0 0 0-3.531 3.533V4.68H1.867a1.192 1.192 0 0 0 0 2.385h1.147v15.19a3.53 3.53 0 0 0 3.532 3.533h11.698a3.53 3.53 0 0 0 3.531-3.533V7.067h1.148a1.192 1.192 0 0 0 0-2.385zM5.399 7.066v15.19c0 .635.514 1.149 1.148 1.149h11.698c.634 0 1.148-.514 1.148-1.149V7.067z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M14.783 10.315c.599 0 1.085.536 1.085 1.198v7.059c0 .662-.486 1.198-1.085 1.198-.6 0-1.086-.536-1.086-1.198v-7.059c0-.662.486-1.198 1.086-1.198M10.225 10.315c.719 0 1.302.536 1.302 1.198v7.059c0 .662-.583 1.198-1.302 1.198s-1.303-.536-1.303-1.198v-7.059c0-.662.583-1.198 1.303-1.198",
    clipRule: "evenodd"
  })));
};
export default SvgDeleteAlert;